import { render, staticRenderFns } from "./extraOrder.vue?vue&type=template&id=6d145c62&scoped=true&"
import script from "./extraOrder.vue?vue&type=script&lang=js&"
export * from "./extraOrder.vue?vue&type=script&lang=js&"
import style0 from "./extraOrder.vue?vue&type=style&index=0&id=6d145c62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d145c62",
  null
  
)

export default component.exports